
import { Component, Inject, Prop } from "vue-property-decorator";
import VueI18n from "vue-i18n";
import { TypedVue } from "@/store/types";
import ElraReport8HeroRadar from "./ElraReport8HeroRadar.vue";

@Component({ components: { ElraReport8HeroRadar } })
export default class ElraReport8Hero extends TypedVue {
  @Inject("$i18n") readonly $i18n!: VueI18n;

  @Prop({ required: true }) candidateDisplayName!: string;
  @Prop({ required: true }) readinessLabel!: string;
  @Prop({ required: true }) heroDescription!: string;
  @Prop({ required: true }) prioritizedCount!: number;
  @Prop({ required: true }) totalCount!: number;
  @Prop({ required: true }) assessmentDate!: string;
  @Prop({ required: true }) orientationStats!: Array<{ letter: string; label: string; prioritizedCount: number; totalCount: number }>;
  @Prop({ default: () => ({}) }) traitScores!: Record<string, number>;
  @Prop({ default: () => ({}) }) traitPriorities!: Record<string, "high" | "mixed" | "low">;
  @Prop({ default: "" }) radarColor!: string;
  @Prop({ default: "" }) theme!: string;

  // The eyebrow literal is "… · {date}". Render it with a sentinel in place of the date and
  // split around it, so the date can be styled separately without changing the literal.
  get eyebrowParts(): { before: string; after: string } {
    const sentinel = "\u0000";
    const [before = "", after = ""] = this.$t("Report::v8::Hero::Eyebrow", { date: sentinel }).toString().split(sentinel);
    return { before, after };
  }

  get hasTraitScores(): boolean {
    return Object.keys(this.traitScores).length > 0;
  }
}
